
import { defineComponent } from "vue";
import MainAboutMenu from "@/components/aboutmenu/MainAboutMenu.vue";

export default defineComponent({
  setup() {
    return {};
  },
  components: {
    MainAboutMenu
  }
});
